export default "__VITE_ASSET__BrYNxPao__"